var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 22.5C44 34.3741 34.3741 44 22.5 44C10.6259 44 1 34.3741 1 22.5C1 10.6259 10.6259 1 22.5 1C34.3741 1 44 10.6259 44 22.5Z",
    stroke: "#F4F4F4",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5445 15.4678C32.4787 15.7151 33.2145 16.4398 33.4653 17.3583C33.9308 19.0348 33.909 22.53 33.909 22.53C33.909 22.53 33.9057 26.0059 33.4544 27.6813C33.2004 28.5987 32.4613 29.3224 31.5281 29.5686C29.8209 30.0075 22.9912 30 22.9912 30C22.9912 30 16.1801 29.9925 14.4555 29.5322C13.5201 29.2849 12.7843 28.5602 12.5335 27.6427C12.0866 25.9834 12.0909 22.4893 12.0909 22.4893C12.0909 22.4893 12.0953 19.0123 12.5455 17.3359C12.7984 16.4184 13.555 15.6776 14.4707 15.4325C16.179 14.9925 23.0076 15 23.0076 15C23.0076 15 29.8373 15.0075 31.5445 15.4678ZM20.8283 19.2873L20.8229 25.7104L26.5047 22.5042L20.8283 19.2873Z",
    fill: "#FF4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.6d9abc2789e8deaf5b6b180d01c35cc5.svg";
export { ForwardRef as ReactComponent };